import { FilterType } from 'civil-status/pages/research-category/list';
import { ResearchAct } from 'civil-status/view-models/research-category-form';

export const transformerActResearch = (values: ResearchAct, idCat?: string): FilterType => {
  return {
    criteriRicercaEvento: {
      idAnsc: values.idAct || undefined,
      idEvento: values.idEvent || undefined,
      idTipoEvento: idCat || values.idCat || undefined,
      dataDa: values.dateStart ? values.dateStart.toFormat('yyyy-MM-dd') : undefined,
      dataA: values.dateEnd ? values.dateEnd.toFormat('yyyy-MM-dd') : undefined,
      idComuneRegistrazione: values.municipality?.code?.toString() || undefined,
      // codiceStatoEvento: values.stateAct || undefined,
    },
  };
};
